




































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, {ALERT_TYPE, VIEW_MODE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import ReportTypeDialogComponent from '@/components/ReportTypeDialogComponent.vue'
import { ReportType } from '@/domain/ReportType'
import ReportTypesService from '@/service/ReportTypesService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    ReportTypeDialogComponent,
  },
})
export default class MasterReportTypeList extends Mixins(GlobalMixin) {
  reportTypesService = ReportTypesService.instance

  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "報告書タイプコード", value: "code", width: "200px" },
          { text: "報告書名", value: "name" },
          { text: "操作", value: "actions", sortable: false, width: "60px" },
  ]
  list: ReportType[] = []
  rowItemKey = ""
  rowItemClickTime = 0

  dto: ReportType =  new ReportType()
  reportTypeDialog = false

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    this.search()
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: ReportType) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.code) {
      this.onEdit(event.code)
    }
    this.rowItemKey = event.code
    this.rowItemClickTime = now
  }

  /**
   * 新規作成
   */
  onNew() {
    this.reportTypesService.createNew()
      .then(x => {
        this.viewMode = VIEW_MODE.NEW
        this.dto = x
        this.reportTypeDialog = true
      })
  }

  /**
   * 編集
   */
  onEdit(code: string) {
    this.reportTypesService.edit(code)
      .then(x => {
        this.viewMode = VIEW_MODE.EDIT
        this.dto = x
        this.reportTypeDialog = true
      })
  }

  /**
   * ダイアログの確定処理
   */
  onReportTypeSubmit(dto: ReportType) {
    this.showLoading()
    if (this.viewMode === VIEW_MODE.NEW) {
      /* 新規登録 */
      this.reportTypesService.create(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    } else {
      /* 更新 */
      this.reportTypesService.update(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    }
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    this.reportTypesService.findAll()
      .then(x => {
        this.list = x
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
